import React, { useContext, useEffect, useState } from 'react';
import { FirebaseContext } from '../../context/firebase';
import * as PROJECT_CODE from '../../constants/projectCode';
import getProfileData from '../../api/Profile/getProfileData.api';
import { ListenForUnrealVMMessages } from '../../api/3DController/ListenForVMMessagesToSelf.api';
import { getProfile } from '../../redux/profile/action';
import { connect } from 'react-redux';
import './AWSController.css';

const AWSController = ({
	entryData,
	connectToHost,
	profileData,
	closeModalCallBack,
}) => {
	const { firebase } = useContext(FirebaseContext);
	//const {entryData} = props;
	var currentUserId = firebase.auth().currentUser.uid;

	useEffect(() => {
		console.log('get dataiiii');
		ListenForUnrealVMMessages(currentUserId, closeModalCallBack);
	}, [profileData]);
	// fullName: profileData?.fullName,
	// email: profileData?.email,
	// phoneNumber: profileData?.phoneNumber,
	// companyName: profileData?.companyName,

	// userEmail,
	// userFullName,
	// userPhoneNumber,
	// userAppointmentTimeUnix,
	// thisUserType,
	// thisAppointmentId,
	// thisUserId,
	// thisIframeName
	var iFrameName = 'furioosContainer_homes';
	var currentUserId = firebase.auth().currentUser.uid;
	console.log('ENTRY DATA' + JSON.stringify(entryData));

	var userTime = Date.now();
	//instanceIp.split('.').join('-');
	var FullNameReplace = 'PlaceHolder';
	if (profileData?.fullName) {
		FullNameReplace = profileData?.fullName.split(' ').join('-');
	}
	let originUrlWithParameters =
		'https://gcp-vm-connector.web.app?' +
		'hostIp=' +
		'000.000.000.000' +
		'&projectCode=' +
		PROJECT_CODE.projectCode +
		'&userEmail=' +
		profileData?.email +
		'&userFullName=' +
		FullNameReplace +
		'&userPhoneNumber=' +
		profileData?.phoneNumber +
		'&userAppointmentTimeUnix=' +
		userTime +
		'&userType=' +
		profileData?.userType +
		'&appointmentId=' +
		currentUserId +
		'&userId=' +
		currentUserId +
		'&myUnit=' +
		entryData['unitId'] +
		'&myElevation=' +
		entryData['elevationId'] +
		'&connectToHost=' +
		connectToHost.toString();

	//var foundIframe = document.getElementById(iFrameName);

	// var vmIframe = document.createElement('iframe');
	// vmIframe.style.width = "100%";
	// vmIframe.style.height = "100%";
	// vmIframe.src = originUrlWithParameters;

	//foundIframe.append(vmIframe);

	console.log('user_type ' + profileData?.userType);
	console.log('originUrlWithParameters ' + originUrlWithParameters);

	return (
		<>
			<div className='aws_container'>
				<iframe
					src={originUrlWithParameters}
					frameBorder='0'
					className='aws_iframe'
				></iframe>
			</div>
		</>
	);
};

const mapStateToProps = (state) => ({
	user: state.signIn,
	profileData: state.profile.profileInfo,
	loading: state.profile.profileInfo.loading,
	rolesAccessibilities: state.userManagement.rolesAccessibilities,
});

export default connect(mapStateToProps, { getProfile })(AWSController);
